function EditBookingController() {
    this.constructor.apply(this, arguments);
}

EditBookingController.$inject = ['$scope', '$state', 'VehicleBookingService', '$mdDialog', '$stateParams', '$message', '$Loading', '$translationService', 'DeviceService', 'CameraService', 'AttackmentService', '$timeout', '$mdToast', 'AuthService'];
EditBookingController.prototype = {
    /**
     *
     * @param $scope
     * @param $state
     * @param VehicleBookingService {VehicleBookingService}
     * @param $mdDialog
     * @param $stateParams
     * @param $message
     * @param $Loading{$Loading}
     * @param $translationService
     * @param DeviceService{DeviceService}
     * @param CameraService {CameraService}
     * @param AttackmentService {AttackmentService}
     * @param $timeout {$timeout}
     * @param $mdToast {$mdToast}
     * @param AuthService {AuthService}
     * @constructor
     */
    constructor($scope, $state, VehicleBookingService, $mdDialog, $stateParams, $message, $Loading, $translationService, DeviceService, CameraService, AttackmentService, $timeout, $mdToast, AuthService) {
        this.$scope = $scope;
        this.$state = $state;
        this.vehicleBookingService = VehicleBookingService;
        this.$mdDialog = $mdDialog;
        this.$stateParams = $stateParams;
        this.$message = $message;
        this.$Loading = $Loading;
        this.$translationService = $translationService;
        this.deviceService = DeviceService;
        this.cameraService = CameraService;
        this.attackmentService = AttackmentService;
        this.$timeout = $timeout;
        this.$mdToast = $mdToast;
        this.authService = AuthService;

        this.apo = null;
        this.$files = [];

        /** @type IVehicleBooking */
        this.item = null;





        this.$scope.vm = this;


        this.$element = $("#internal-booking-page");
           
        if (this.$stateParams.id) { //Edit 
            this.getVehicleBooking(this.$stateParams.id)
                .finally(this.$Loading.blockUI())
                .then((item) => {
                    this.item = item;
                    this.$files = this.getAttachmentFiles(item.Attachments);
                }, this.$message.error);
        } else { //Add new booking
            this.item = JSON.parse(this.$stateParams.vehicleBooking)||{};
            // Add driverName to display
            this.item.DriverName = this.authService.getAuthenticatedUser().UserName;
        }
        this.bindEvents();
        this.watch();

    },
    bindEvents() {

        /**
         * Hide time picker when close this page
         */
        this.$scope.$on("$destroy", () => {
            //Close picker when destroy scope
            if (this.apo)
                this.apo._hidePicker();
        });
    },
    watch() {
       
        /**
         * Update EndDate if StartDate is more than StartDate
         */
        this.$scope.$watch("vm.item.StartDate", (newValue, oldValue) => {
            if (newValue !== oldValue) {
                if (moment(newValue, "YYYY-MM-DD").diff(moment(this.item.EndDate, "YYYY-MM-DD")) >= 0) {
                    this.item.EndDate = moment(newValue, "YYYY-MM-DD").format("YYYY-MM-DD");
                }
            }
        });
    },
    /**
     * Go back to prev page
     */
    goBack() {
        let params = {};
        if (this.$stateParams.state
        )
            params = JSON.parse(this.$stateParams.state);
        this.$state.go(this.$stateParams.prevState, params);
    },


    /**
     * Onsubmit to save booking
     */
    submit() {
        //Show error if files upload fail
        if (this.attackmentService.isExistFileUploadFail(this.$files)) {
            this.$mdToast.show(this.$mdToast
                .simple()
                .position("right top")
                .textContent(this.$message.get('FileUploadFail'))
                .action(this.$translationService.getTranslation('OK'))
                .hideDelay(6000));
            return;
        }
        // Show error if files is uploading
        if (this.attackmentService.isUploading(this.$files)) {
            this.$mdToast.show(this.$mdToast
                .simple()
                .position("right top")
                .textContent(this.$message.get('FileUploadPending'))
                .action(this.$translationService.getTranslation('OK'))
                .hideDelay(6000));
            return;
        }

        /** @type IVehicleBooking */
        let item = {
            StartDate: this.item.StartDate,
            EndDate: this.item.EndDate,
            StartTime: this.item.StartTime,
            EndTime: this.item.EndTime,
            VehicleId: this.item.VehicleId,
            Description: this.item.Description,
            Attachments: this.getAttachments(this.$files)
        };
        if (this.item.Id)
            item.Id = this.item.Id;
        this.$Loading.show({
            title: this.$translationService.getTranslation('Saving')
        });
        this.save(item)
            .then(() => {
                let params = {};
                if (this.$stateParams.state){
                    this.travelState(this.$stateParams.state,(state)=>{
                        if(state && state.stateName && state.stateName==='internal.vehiclebookings'){
                           params = state;
                        }
                    })
                }
     
                this.$state.go("internal.vehiclebookings", params);
            }, this.$message.error)
            .finally(() => {
                this.$Loading.hide();
            });
    },
    
    
    
    /**
     * Save booking
     * @param {IVehicleBooking} booking
     * @returns {any}
     */
    save(booking) {
        return this.vehicleBookingService.saveVehicleBooking(booking);
    },
    /**
     * Show StartDate picker
     * @param $event
     */
    showStartDatePickerModal($event) {
        let minDate = "";
        if (!this.item.Id)
            minDate = moment().format('YYYY-MM-DD');
        this.showDatePickerModal('StartDate', $event, minDate);
    },
    /**
     * Show EndDate picker
     * @param $event
     */
    showEndDatePickerModal($event) {
        let minDate = this.item.StartDate;
        this.showDatePickerModal('EndDate', $event, minDate);
    },
    /**
     * Show date picker
     * @param {string} name
     * @param {MouseEvent} $event
     * @param minDate
     */
    showDatePickerModal(name, $event, minDate) {
        let local = {
            date: moment(this.item[name], "YYYY-MM-DD"),
            options: {
                hidenClearButton: true
            }
        };
        if (minDate)
            local.options.minDate = minDate;
        this.$mdDialog.show({
            controller: DatePickerController,
            controllerAs: 'vm',
            templateUrl: 'js/shared/directives/datepicker/datepicker.html',
            clickOutsideToClose: true,
            escapeToClose: true,
            hasBackdrop: true,
            targetEvent: $event,
            locals: local,
            focusOnOpen: false
        }).then((result) => {
            if (name === 'StartDate') {
                if (moment(this.item.StartDate).format('YYYY-MM-DD') !== result) {
                    let startTime = '00:00';
                    if (result === moment().format('YYYY-MM-DD')) { //select today
                        startTime = moment().format('HH:mm');
                    }
                    this.item.StartTime = startTime;
                }
            }
            this.item[name] = result;
        });
    },
   
    safeApply(fn) {
        let phase = this.$scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        } else {
            this.$scope.$apply(fn);
        }
    },
    /**
     * Show time picker
     * @param {string} name
     * @param {boolean} isShow59
     * @param {MouseEvent} $event
     */
    showTimePicker(name, isShow59, $event) {
        let headerTitle = this.$translationService.getTranslation(name);
        function convertToString(value) {
            let strValue;
            if (value < 10)
                strValue = "0" + value;
            else
                strValue = value.toString();
            return strValue;
        }

        function createDataSource() {
            let dataSource = [];
            let hours = [];
            for (let i = 0; i <= 23; i++) {
                hours.push({
                    val: convertToString(i),
                    label: convertToString(i)
                });
            }
            let minutes = [];
            for (let i = 0; i < 59; i = i + 5) {
                minutes.push({
                    val: convertToString(i),
                    label: convertToString(i)
                });
            }
            if (isShow59) {
                minutes.push({
                    val: "59",
                    label: "59"
                });
            }
            //Push minute to minutes if minute don't exist in list
            let time = this.item[name], pices = time.split(":"), minute = convertToString(parseInt(pices[1]));
            let match = _.findIndex(minutes, function (obj) {
                return obj.val === minute;
            });
            if (match === -1) {
                for (let i = 0; i < minutes.length; i++) {
                    if (parseInt(minute) < parseInt(minutes[i].val)) {
                        minutes.splice(i, 0, {
                            val: minute,
                            label: minute
                        });
                        break;
                    }
                }
            }
            dataSource.push(hours);
            dataSource.push(minutes);
            return dataSource;
        }

        let oArrData = createDataSource.apply(this);
        let oArrComponents = [
            {
                component: 0,
                name: "hours",
                label: "Hours",
                width: "50%",
                textAlign: "center"
            },
            {
                component: 1,
                name: "minutes",
                label: "Minutes",
                width: "50%",
                textAlign: "center"
            }
        ], oArrDataSource = [
            {
                component: 0,
                data: oArrData[0]
            },
            {
                component: 1,
                data: oArrData[1]
            }
        ];
        let apo = null;


        // Hide time-picker if press back-button
        /** @type {angular.IScope} */
        let currentScope = this.$scope.$new(true);
        this.deviceService.onGoBackButton(currentScope, () => {
            if (this.apo) {
                this.apo._hidePicker();
            }
        });
        $("<input/>").AnyPicker({
            i18n: {
                headerTitle: headerTitle,
                setButton: this.$translationService.getTranslation('Set'),
                clearButton: this.$translationService.getTranslation('Clear'),
                nowButton: this.$translationService.getTranslation('Now'),
                cancelButton: this.$translationService.getTranslation('Cancel'),
                dateSwitch: this.$translationService.getTranslation('Date'),
                timeSwitch: this.$translationService.getTranslation('Time'),
            },
            mode: "select",
            onInit: function () {
                apo = this;
            },
            formatOutput: (oArrSelectedValues) => {
                return moment(oArrSelectedValues.values[0].val + ":" + oArrSelectedValues.values[1].val, "HH:mm").format("HH:mm");
            },
            onSetOutput: (sOutput) => {
                this.item[name] = sOutput;
                this.safeApply();
            },
            parseInput: () => {
                if (!this.item[name])
                    return ["00", "00"];
                let time = this.item[name], pices = time.split(":"), hour = convertToString(parseInt(pices[0])),
                    minute = convertToString(parseInt(pices[1]));
                return [hour, minute];
            },
            showComponentLabel: false,
            components: oArrComponents,
            dataSource: oArrDataSource,
            onBeforeHidePicker: () => {
                // Destroy currentScope when time-picker is hide
                currentScope.$destroy();
            }
        });
        apo.showOrHidePicker($($event.target).closest('md-input-container').find("input")[0]);
        this.apo = apo;
    },
    /**
     * Get booking from id
     * @param {string} id
     * @returns {any}
     */
    getVehicleBooking(id) {
        return this.vehicleBookingService.getVehicleBooking(id);
    },


    uploadEventFiles($files) {
        this.$files = Array.prototype.concat(this.$files, this.attackmentService.getFiles($files));
    },

    showPhotosOrDocuments($event) {
        this.cameraService
            .showPhotosOrDocumentsPanel($event, {
                onStart: () => {
                },
                acceptOnlyPicture: false
            })
            .then((data) => {
                if (data) { // have file
                    if (!Array.isArray(data)) { // Convert to array if have a file
                        data = [data];
                    }
                    if (data.length > 0) {
                        this.uploadEventFiles(data);
                    }
                }
            });
    },


    /**
     * Get attachments from files to send to server
     * @param {IAttachment[]} $files
     * @returns {IAttachment[]}
     */
    getAttachments($files) {
        let attachments = [];
        $files.forEach(($file) => {
            let file = {
                Id: $file.Id,
                Name: $file.Name,
                DocumentId: $file.DocumentId
            }
            if ($file.isNew) { // don't send id if file is new
                delete file.Id
            }
            attachments.push(file);

        })
        return attachments;
    },

    /**
     * Get attachments from attachments 
     * @param attachments {IAttachment[]}}
     */
    getAttachmentFiles(attachments) {
        attachments.forEach((attachment) => {
            attachment.iconClass = this.attackmentService.getIcon(attachment.Name);
            attachment.isPhoto = this.attackmentService.isPhoto(attachment.Name);
        });
        return attachments;
    },

    /**
     * Travel state
     * @param state
     * @param callback
     */
    travelState(state, callback){
        if(state){
            state = JSON.parse(state);
            callback(state);
            if(state.state){
                this.travelState(state.state, callback);
            }
        }
    }

}

angular.module('internal.vehiclebookings').controller('EditBookingController', EditBookingController);